import { render, staticRenderFns } from "./CampaignLanding.vue?vue&type=template&id=5cfca48f&scoped=true&"
import script from "./CampaignLanding.vue?vue&type=script&lang=js&"
export * from "./CampaignLanding.vue?vue&type=script&lang=js&"
import style0 from "./CampaignLanding.vue?vue&type=style&index=0&id=5cfca48f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfca48f",
  null
  
)

export default component.exports